import { get } from "./base";

export async function getIndexTopNews() {
    let respObj = await get("/edu-classroom/platforminformation/homeinfolist/1");
    if (respObj != false) {
        // 处理接口数据
        let result = [];
        for (const dataItem of respObj) {
            let title = dataItem.title;
            let date = dataItem.newsTime;
            let id = dataItem.id;
            result.push({id, title, date})
        }
        return result;
    } else {
        return [];
    }
}
